import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import SiteHeader from "../components/SiteHeader";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("guy@whitesmiledental.ie");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErr("");
    try {
      const res = await api.adminLogin(email, password);
      localStorage.setItem("ws_admin_token", res.token);
      localStorage.setItem("ws_admin_email", res.email);
      nav("/admin/dashboard");
    } catch (e) {
      setErr("Incorrect email or password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="ws-card p-8" data-testid="admin-login-card">
          <div className="w-12 h-12 rounded-xl bg-[#E8F0FE] grid place-items-center mb-4">
            <Lock className="w-5 h-5 text-[#0466ff]" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-extrabold mb-1" style={{ fontFamily: "Manrope" }}>Staff sign-in</h1>
          <p className="text-sm text-[#5C5C5C] mb-6">For White Smile Dental team only.</p>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="text-sm text-[#5C5C5C] mb-1 block">Email</label>
              <input className="ws-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
            </div>
            <div>
              <label className="text-sm text-[#5C5C5C] mb-1 block">Password</label>
              <input type="password" className="ws-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
            </div>
            {err && <div className="text-sm text-[#D0021B]" data-testid="admin-login-error">{err}</div>}
            <button type="submit" disabled={submitting} className="ws-btn-primary w-full" data-testid="admin-login-button">
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
